export const TEAPOT_CHEF = 'Teapot Chef';
